/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, April 8th 2022, 5:02:52 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { URLS } from "core/routes";
import { InviteWorkersIcon, InviteWorkersButtonWrapper } from "onboarding";
import { UserProfilePopOver } from "theme/components/UserProfilePopOver";

export const FirstSideBar = () => {
  return (
    <div className="first-side-bar">
      <div className="first-sidebar-in">
        <Paper className="first-side-bar-in" elevation={0}>
          <Link to={URLS.dashboard}>
            <div className="brand-wrapper-symbol">
              <img className="image-style-A sidebar-logo" src="/img/onestop-symbol-white.svg" alt="Onestop" />
            </div>
          </Link>
        </Paper>
        <div className="first-sidebar-bottom-items">
          <InviteWorkersButtonWrapper>
            <InviteWorkersIcon className="os-sidebar-invite-workers" />
          </InviteWorkersButtonWrapper>
          <UserProfilePopOver />
        </div>
      </div>
    </div>
  );
};
